import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import Select from "react-select";
import { Button } from "react-bootstrap";
import { Trash, Check2, X } from "react-bootstrap-icons";
import AdminSidebar from "../../layouts/AdminSidebar";
import { authCall } from "../../../services";
import AppConstants from "../../../appConstants";
import "./wallOffFame.css";

const FILTER = [
  { label: "Pending", value: "Pending" },
  { label: "Approved", value: "Approved" },
];
function SunnyMoments() {
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;
  const isArchivedList =
    AppConstants.routes.admin.archivedEvents.includes(pathname);
  const [sunnyList, setSunnyList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingStatus, setLoadingStatus] = useState("");
  const [selectedOption, setSelectedOption] = useState({
    label: "Pending",
    value: "Pending",
  });

  const getSunnyMoment = async (type) => {
    setLoading(true);
    const resp = await authCall("getSunnyMoment", {type});
    if (resp?.type === "success") {
      setSunnyList(resp?.payload);
      setLoading(false);
    }
  };

  useEffect(() => {
    getSunnyMoment('pending');
  }, []);

  const handleEdit = (details) => {
    navigate(AppConstants.routes.admin.addHotelStaff, {
      state: { details },
    });
  };

  const handleDelete = (el) => {
    toast.warning(
      <div>
        <p>Are you sure you want to delete?</p>
        <Button
          variant="success"
          className="btn-sm"
          onClick={() => deleteItem(el)}
        >
          Yes
        </Button>
        <Button
          variant="danger"
          className="btn-sm"
          style={{ marginLeft: "2px" }}
          onClick={closeToast}
        >
          No
        </Button>
      </div>,
      {
        position: "top-center",
        autoClose: false,
        closeOnClick: false,
        draggable: false,
        closeButton: false,
      }
    );
  };

  const deleteItem = async (el) => {
    const resp = await authCall("deleteStaff", {
      staffId: el.id,
      isSoft: false,
    });
    if (resp?.type === "success") {
      closeToast();
      const updatedItems = sunnyList.filter((item) => item.id !== el.id);
      setSunnyList(updatedItems);
      toast.success("Deleted successfully.");
    }
  };

  const closeToast = () => {
    toast.dismiss();
  };

  const handleChangeType = (selected) => {
    setSelectedOption(selected);
    getSunnyMoment(selected.label);
  };

  return (
    <>
      <div className="update-machine-page common-table-design py-4">
        <div className="container custom-container">
          <div className="row">
            <div className="col-sm-4 col-lg-3 mb-4">
              <AdminSidebar />
            </div>
            <div className="col-sm-8 col-lg-9">
              <div className="common-info-card">
                <div className="heading-title">Sunny Moments</div>
                <div className="details-wrapper py-lg-4">
                  <Row className="align-items-center mb-4">
                    <Col xs={4}>
                      <Select
                        className="text-body mt-1"
                        value={selectedOption}
                        onChange={handleChangeType}
                        options={FILTER}
                      />
                    </Col>
                  </Row>
                  <div className="row">
                    <div className="col-12 d-flex flex-wrap justify-content-left gap-3">
                      {!loading ? (
                        sunnyList.length > 0 ? (
                          sunnyList.map((el, index) => (
                            <div className="img-hover-wrapper position-relative">
                              <img
                                src={el?.sunny_image}
                                className="img-fluid rounded"
                                alt="cropped"
                                style={{
                                  maxHeight: "140px",
                                  objectFit: "cover",
                                  width: "100%",
                                }}
                              />

                              {/* Remove button */}
                              <button
                                className="remove-btn btn btn-danger btn-sm"
                                // onClick={() => handleRemove(index)}
                              >
                                <Trash />
                              </button>

                              {/* Bottom overlay buttons */}
                              <div className="img-action-overlay d-flex justify-content-center gap-3">
                                <button
                                  className="btn btn-success btn-sm"
                                  title="Approve"
                                >
                                  <Check2 />
                                </button>
                                <button
                                  className="btn btn-danger btn-sm"
                                  title="Disapprove"
                                >
                                  <X />
                                </button>
                              </div>
                            </div>
                          ))
                        ) : (
                          <p>No sunny moments available.</p>
                        )
                      ) : (
                        <p>Loading...</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SunnyMoments;
